import { formatDate } from '@/utils'

export const permill = value => {
    if(value === 0) return value
    if (!value) return ''
    value = value.toString()
    let vals = value.split('.')
    if(vals.length === 2 && vals[1].length > 2){
        value = parseFloat(value).toFixed(2)
    }
    return value.replace(/\d(?=((\d{3})+)(\.|$))/g, k => k + ',')
}

export const minutesTransfer = value => {
    let result = ''
    let h = parseInt(value / 60)
    let m = value % 60
    if(h == 0 && m == 0){
        result = '0分钟'
    }else if(h != 0 && m != 0){
        result = h + '小时' + m + '分钟'
    }else if(h == 0 && m != 0){
        result = m + '分钟'
    }else if(h != 0 && m == 0){
        result = h + '小时'
    }
    return result
}

export const minutesTransfer2 = value => {
    let result = ''
    let h = parseInt(value / 60)
    let m = value % 60
    if(h == 0 && m == 0){
        result = '0<span class="time-unit">min</span>'
    }else if(h != 0 && m != 0){
        result = permill(h) + '<span class="time-unit">h</span>' + m + '<span class="time-unit">min</span>'
    }else if(h == 0 && m != 0){
        result = m + '<span class="time-unit">min</span>'
    }else if(h != 0 && m == 0){
        result = permill(h) + '<span class="time-unit">h</span>'
    }
    return result
}

export const minutesTransfer3 = value => {
    let result = ''
    let h = parseInt(value / 60)
    let m = value % 60
    if(h == 0 && m == 0){
        result = '0<span class="time-unit-suffix">min</span>'
    }else if(h != 0 && m != 0){
        result = h + '<span class="time-unit-suffix">h</span>' + ' ' + m + '<span class="time-unit-suffix">min</span>'
    }else if(h == 0 && m != 0){
        result = m + '<span class="time-unit-suffix">min</span>'
    }else if(h != 0 && m == 0){
        result = h + '<span class="time-unit-suffix">h</span>'
    }
    return result
}

export const secondsTransfer = value => {
    var h = parseInt(value / (60 * 60)),
        m = parseInt((value % (60 * 60)) / 60),
        s = parseInt(value % 60)
    h = h < 10 ? '0' + h : h
    m = m < 10 ? '0' + m : m
    s = s < 10 ? '0' + s : s
    return h + ':' + m + ':' + s
}

export const secondsTransfer2 = value => {
    var m = parseInt(value / 60),
        s = parseInt(value % 60)
    m = m < 10 ? '0' + m : m
    s = s < 10 ? '0' + s : s
    return m + ':' + s
}

export const calcAge = value => {
    if(!value){
        return ''
    }
    var now = new Date(),
        birthday = new Date(value),
        years = now.getFullYear() - birthday.getFullYear()
    if(formatDate(now).substring(4) < formatDate(birthday).substring(4)){
        years -= 1
    }
    return years
}

export const avatarDefault = value => {
    if(!value){
        return 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'
    }
    return value
}

export const sensitiveTelephone = value => {
    if(!value){
        return value
    }
    return value.replace(/(\d{3})\d{4}(\d{4})/, function(k, a, b){
        return a + '****' + b
    })
}

export const sensitiveIdCard = value => {
    if(!value){
        return value
    }
    return value.replace(/\d{14}[(\d{4})(\d{3}x|X)]/, function(k, a){
        return '**************' + a
    })
}

export const ellipsisTxt = value => {
    if(value.length < 10){
        return value
    }
    return value.substr(0, 6) + '…' + value.substr(value.length - 3)
}

export const dateTimeBr = value => {
    if(!value || value == '--' || value.length <= 8){
        return value
    }
    return value.split(' ').join('<br>')
}

export function ymd(date){
    if(!date) return
    return date.split(' ')[0]
}

export function hm(date){
    if(!date) return
    var time = date.split(' ')[1]
    if(time.length > 5){
      time = time.substring(0,5)
    }
    return time
}

export function hms(date){
    if(!date) return
    var time = date.split(' ')[1]
    return time
}

export function week(date){
    if(!date) return
    var weeks = ['日', '一', '二', '三', '四', '五', '六']
    return weeks[new Date(date).getDay()]
}


export default {
    install(Vue){
        Vue.filter('permill', permill)
        Vue.filter('minutesTransfer', minutesTransfer)
        Vue.filter('minutesTransfer2', minutesTransfer2)
        Vue.filter('minutesTransfer3', minutesTransfer3)
        Vue.filter('secondsTransfer', secondsTransfer)
        Vue.filter('secondsTransfer2', secondsTransfer2)
        Vue.filter('calcAge', calcAge)
        Vue.filter('avatarDefault', avatarDefault)
        Vue.filter('sensitiveTelephone', sensitiveTelephone)
        Vue.filter('sensitiveIdCard', sensitiveIdCard)
        Vue.filter('ellipsisTxt', ellipsisTxt)
        Vue.filter('dateTimeBr', dateTimeBr)
        Vue.filter('ymd', ymd)
        Vue.filter('hms', hms)
        Vue.filter('hm', hm)
        Vue.filter('week', week)
    }
}


// WEBPACK FOOTER //
// ./src/filters/index.js